export default [
    {
        path: 'requisicao-abertura-fechamento',
        component: () => import(
            /* webpackChunkName: 'almoxarifado-requisicao-abertura-fechamento' */
            '@/views/almoxarifado/requisicao-abertura-fechamento/Index'
        ),
        redirect: 'requisicao-abertura-fechamento/index',
        children: [
            {
                name: 'almoxarifado-requisicao-abertura-fechamento-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'almoxarifado-requisicao-abertura-fechamento' */
                    '@/views/almoxarifado/requisicao-abertura-fechamento/List.vue'
                ),
            },
            {
                name: 'almoxarifado-requisicao-abertura-fechamento-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'almoxarifado-requisicao-abertura-fechamento' */
                    '@/views/almoxarifado/requisicao-abertura-fechamento/Form.vue'
                ),
            },
            {
                name: 'almoxarifado-requisicao-abertura-fechamento-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'almoxarifado-requisicao-abertura-fechamento' */
                    '@/views/almoxarifado/requisicao-abertura-fechamento/Form.vue'
                ),
            },
        ],
    },
]